<div class="sin-resultados">
    <neo-icono [iconoClase]="'icon-24 icon-ibm--information'"></neo-icono>
    <p class="text-h3">{{texto}}</p>
</div>
